import React from 'react';
import { motion } from 'framer-motion';
import { PhoneIcon, ArrowRightIcon } from 'lucide-react';
import { Button } from './ui/Button';
export function FinalCTASection() {
  return <section className="py-24 bg-viridia-600 text-white relative overflow-hidden" data-id="element-45">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10" data-id="element-46">
        <div className="absolute top-0 left-0 w-64 h-64 bg-white rounded-full mix-blend-overlay filter blur-3xl transform -translate-x-1/2 -translate-y-1/2" data-id="element-47" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full mix-blend-overlay filter blur-3xl transform translate-x-1/2 translate-y-1/2" data-id="element-48" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-49">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-5xl font-bold mb-6" data-id="element-50">
          Stop Losing Leads to Voicemail.
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-xl text-viridia-50 mb-4 max-w-2xl mx-auto" data-id="element-51">
          Call Jessica now and see how many more appointments she can book for
          you.
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.15
      }} className="text-lg text-white/90 font-medium italic mb-10" data-id="element-52">
          Start capturing tonight's calls instead of losing them.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="flex flex-col sm:flex-row gap-4 justify-center items-center" data-id="element-53">
          <Button variant="ghost" size="lg" className="w-full sm:w-auto bg-white text-viridia-700 hover:bg-viridia-50 shadow-lg border-0" onClick={() => window.location.href = 'tel:6233000708'} data-id="element-54">
            <PhoneIcon className="w-5 h-5 mr-2" data-id="element-55" />
            Call the AI Demo Now – 623-300-0708
          </Button>

          <Button variant="outline" size="lg" className="w-full sm:w-auto border-2 border-white text-white hover:bg-white/10 hover:text-white bg-transparent" onClick={() => window.open('https://api.viridiaanalytics.com/payment-link/699612346c8c04e29116c945', '_blank')} data-id="element-56">
            Get Started for $697/month Today
            <ArrowRightIcon className="w-5 h-5 ml-2" data-id="element-57" />
          </Button>
        </motion.div>
      </div>
    </section>;
}